import GuideAI from 'guideai-app';

import './styles.less';

export type GuideAIAppHandlerComponentProps = {
  organizationKey: string;
};

const GuideAIAppHandlerComponent = ({ organizationKey }: GuideAIAppHandlerComponentProps) => {
  return (
    <div>
      <GuideAI organizationKey={organizationKey} key="k" position={{}} onError={(error) => console.error(error)} />
    </div>
  );
};

export default GuideAIAppHandlerComponent;
